import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pxwFilterProductsByCategory',
  standalone: true,
})
export class FilterProductsByCategoryPipe<T extends { categoryId: string }>
  implements PipeTransform
{
  transform(products: T[], categoryId: string | null = null): any {
    if (!categoryId) {
      return products;
    }
    return products.filter(product => product.categoryId === categoryId);
  }
}
